var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 10,
    viewBox: "0 0 6 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.266469 0.263092C0.181999 0.345946 0.114984 0.444362 0.0692601 0.552705C0.0235359 0.661048 0 0.77719 0 0.894485C0 1.01178 0.0235359 1.12792 0.0692601 1.23626C0.114984 1.34461 0.181999 1.44302 0.266469 1.52588L3.80184 5.00078L0.266469 8.47568C0.0960988 8.64314 0.000385821 8.87026 0.000385821 9.10707C0.000385821 9.34389 0.0960988 9.57101 0.266469 9.73847C0.436838 9.90593 0.667909 10 0.908848 10C1.14979 10 1.38086 9.90593 1.55123 9.73847L5.73353 5.6277C5.818 5.54484 5.88502 5.44642 5.93074 5.33808C5.97646 5.22974 6 5.1136 6 4.9963C6 4.87901 5.97646 4.76287 5.93074 4.65452C5.88502 4.54618 5.818 4.44776 5.73353 4.36491L1.55123 0.254135C1.20498 -0.08619 0.621828 -0.0861898 0.266469 0.263092Z",
    fill: "#1e4fa3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueArrow);
export default __webpack_public_path__ + "static/media/blue-arrow.19649c735493f5efae92696f66e46818.svg";
export { ForwardRef as ReactComponent };